import React from "react";
import CustomButton from "../../components/customButton/CustomButton";
import Form from "../../components/form/Form";
import "./Home.css";

function Home() {
  return (
    <div className="home_main_container">
      <div className="home_overlay"></div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          padding: "0px 10px",
          zIndex: 2,
        }}
      >
        <div
          style={{
            textAlign: "start",
            display: "flex",
            alignItems: "center",
            fontSize: "42px",
            fontFamily: "sans-serif",
            fontWeight: "bold",
            color: "#fff",
            marginLeft: "20px",
          }}
        >
          LET'S SUPPORT UNEMPLOYED WOMEN'S TO GET TRAINED AND UPSKILL
        </div>
        <div style={{ margin: " 50px 0px" }}>
          <CustomButton />
        </div>
        <div
          style={{
            display: "flex",
            color: "#fff",
            fontSize: "13px",
            // marginTop: "5px",
            marginLeft: "15px",
          }}
        >
          Donations through this platform are tax exempted inder 80G & 501(c)(3)
        </div>
      </div>
      <Form style={{ margin: "0px 20px" }} title="Extend Your Support" />
    </div>
  );
}

export default Home;
